<template>
  <div class="entry-wrapper">
    <div class="contain_wrapper entry-inner container-wrapper">
      <div class="left">
        <div class="book_img" v-if="leftItemDetail">
          <img :src="this.base_img + leftItemDetail[0].Id+'.gif'" alt="" class="img-btn" :onerror="IMG_DEFAULT_URL">
          <div class="reading-btn" @click="handleClickRead(leftItemDetail[0].Id)">阅读</div>
          <p class="title">{{leftItemDetail[0].BookTitle}}</p>
        </div>
        <div class="left_content" v-if="leftItemDetail" :id="leftItemDetail[0].Id">
          <p class="content" v-if="leftItemDetail[0].Content">内容简介：{{leftItemDetail[0].Content}}</p>
        </div>
      </div>
      <div class="right" v-if="itemDetailList">
        <div class="headTop">
          <div class="directory" :class="{on: showDirectory}" @click="handleShowDirectory(true)">
            目录
          </div>
          <input :readonly="readonlyShow" @focus="focusHandle" v-model="innerKeyword" placeholder="书内检索" class="searchInput" @keyup.enter="handleClickSearch"/><span class="iconfont searchIcon" @click="handleClickSearch">&#xe60c;</span>
          <div class="book_search-btn" :class="{on: !showDirectory}" @click="handleShowDirectory(false)" v-show="showBookSearchBtn">
            书内检索
          </div>
        </div>
        <div class="content_inner" v-show="showDirectory">
          <div class="content_left">
            <div class="stoolbar-tree">
              <div class="stoolbar-tree-top"></div>
              <div class="stoolbar-tree-bottom"></div>
            </div>
            <div class="stoolbar-btn">
              <a href="javascript:;" class="stoolbar-btn-up" id="stoolbarBtnUp" title="向上翻页" @click="handleScrollUp"></a>
              <a href="javascript:;" class="stoolbar-btn-down" id="stoolBarBtnDown" title="向下翻页" @click="handleScrollDown"></a>
            </div>
            <div class="stoolbar-dir" ref="leftScroll">
              <ul id="stoolbarDir">
                <li :data-index="index"
                  :class="{current: index===currentIndex}"
                  @click="clickMenuItem(index)"
                  v-for="(item, index) of itemDetailList" :key="index"
                >
                  <h3 :ref="index">
                    <span class="stoolbar-dir-dot"></span>
                    <a href="javascript:;" class="zs_detail_title" :title="item.item.Title">{{item.item.Title}}</a>
                  </h3>
                </li>
              </ul>
            </div>
          </div>
          <div class="content_right" id="scrollDiv">
            <ul id="list" ref="contentUl">
              <li v-for="(itemArrs, index) of itemDetailList" :key="index" :id="index" class="conten-list">
                <span></span>
                <h3>
                  <i :class="{open : ShowItemList}" @click="isShowItemList($event)" v-show="itemArrs.subItemList.length > 0"></i>
                  <span class="iconfont">&#xe6c3;</span>
                  <a @click="handleClickItemRead(itemArrs.item.Id)">{{itemArrs.item.Title}}</a>
                </h3>
                <ul v-if="itemArrs.subItemList.length > 0" ref="showItemList">
                  <li v-for="(itemArr, index) of itemArrs.subItemList" :key="index">
                    <h3 class="secTitle">
                      <i :class="{open : ShowItemList}" @click="isShowItemList($event)" v-show="itemArr.subItemList.length > 0"></i>
                      <span class="iconfont">&#xe6c3;</span>
                      <a @click="handleClickItemRead(itemArr.item.Id)">{{itemArr.item.Title}}</a>
                    </h3>
                    <ul v-if="itemArr.subItemList.length > 0" ref="showItemList">
                      <li v-for="(item, index) of itemArr.subItemList" :key="index">
                        <h3 class="thirTitle">
                          <span class="iconfont">&#xe6c3;</span>
                          <a @click="handleClickItemRead(item.item.Id)">{{item.item.Title}}</a>
                        </h3>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div class="content_search" v-show="!showDirectory">
          <div v-loading="showLoading" class="loading" v-if="showList">
            <div v-for="(item, index) of this.inneritemDetailList" :key="index" class="searchItem">
              <p class="title" @click="handleClickItemRead(item.Id)">
                <span class="item-title item-num"> {{(index+1)+(pageSize) * (curPage - 1)}}</span>
                <span class="item-title" v-html="item.Title_HL || item.Title" :title="item.Title"></span>
              </p>
              <div class="handle-view" @click="handleClickItemRead(item.Id)">阅读</div>
              <div class="handle-download" @click="handleClickItemDown(item.Id)">下载</div>
            </div>
          </div>
          <div class="searchWarn" v-if="!showList">
            <i class="wf-icon icon-information"></i>
            没有命中记录，请重试或修改检索表达式
          </div>
          <Paganition
            v-if="this.totalPage > 1"
            :total= this.hit
            :currentPage= this.curPage
            :pageSize= this.pageSize
            :totalPage = this.totalPage
            @handleCurrentChangeSub="handleCurrentChangeSub"
            name="pagination"
            >
          </Paganition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Paganition from '../../components/Pagination/Pagination'
import BScroll from 'better-scroll'
import {reqSearch, reqItemList, reqInnerItemList} from '../../api/index'
import {mapState} from 'vuex'
import {READ_URL, RESOURCE_TYPE_ITEM_READ, RESOURCE_TYPE_READ, LOGIN_IN_URL, RESOURCE_TYPE_ITEM_DOWN, IMG_BASE_URL, IMG_DEFAULT_URL} from '../../assets/constant'
export default {
  name: 'Detail',
  components: {
    Paganition
  },
  data () {
    return {
      showDirectory: true,
      IMG_DEFAULT_URL: IMG_DEFAULT_URL,
      base_img: IMG_BASE_URL,
      hit: 0,
      totalPage: 0,
      curPage: 1,
      pageSize: 10,
      ShowItemList: true,
      innerKeyword: '',
      scrollY: 0, // 右侧滑动的Y轴坐标 (滑动过程时实时变化)
      tops: [], // 所有右侧分类li的top组成的数组  (列表第一次显示后就不再变化)
      food: {}, // 需要显示的food
      clickCurrentIndex: 0,
      showBookSearchBtn: false,
      leftItemDetail: '',
      itemDetailList: [],
      inneritemDetailList: [],
      innerItemObj: {},
      showLoading: false,
      showList: false,
      readonlyShow:true
    }
  },
  computed: {
    ...mapState(['userinfo']),
    // 滚动得到当前分类的下标
    currentIndex () { // 初始化和相关数据发生变化，执行
      // 得到条件数据
      const {scrollY, tops} = this
      // 根据条件计算产生一个结果
      const index = tops.findIndex((top, index) => {
        // scrollY >= 当前top && scrollY< 下一个top
        return scrollY >= top && scrollY < tops[index + 1]
      })
      if (scrollY > tops[tops.length - 1]) {
        this.contentScroll.scrollTo(0, -(tops[tops.length - 1] - 43))
        this.clickCurrentIndex = tops.length - 2
        return tops.length - 2
      }
      // 返回结果
      this.clickCurrentIndex = index
      // 滚动左侧列表  /40
      this.$nextTick(() => {
        if (index >= tops.length - 8) {
          return
        }
        this.leftScroll.scrollTo(0, -40 * index, 300)
      })
      return index
    }
  },
  mounted () {
    const itemId = this.$route.query.BookID
    // 左侧itemDeital
    let opt = {
      fq: 'BookID:' + itemId,
      core: 'LocalChronicleEdu'
    }
    let itemDetail = reqSearch(opt)
    itemDetail.then((res) => {
      const data = res.resulter.results
      this.leftItemDetail = JSON.parse(data)
    })
    opt = {
      fq: 'BookID:' + itemId
    }
    itemDetail = reqItemList(opt)
    itemDetail.then((res) => {
      const data = res.resulter.extraData
      this.itemDetailList = JSON.parse(data).subItemList
      this.$nextTick(() => {
        this._initScroll()
        this._initTops()
        this.$nextTick(() => {
          if (this.$route.query.show === 'false') {
            this.showBookSearchBtn = true
            this.showDirectory = false
          }
          if (this.$route.query.show === 'true') {
            this.showBookSearchBtn = true
            this.showDirectory = true
          }
        })
      })
    })
    this._initBookInnerSearch(1)
  },
  methods: {
    // 初始化书内检索
    async _initBookInnerSearch (pageNo) {
      const opt = {
        core: 'LocalChronicleItemEdu',
        fq: 'BookID:' + this.$route.query.BookID,
        query: this.$route.query.queryInner || '',
        pageSize: 10,
        pageNo: pageNo
      }
      this.innerKeyword = this.$route.query.queryInner || ''
      this.showLoading = true
      let innerItme = await reqInnerItemList(opt)
      this.showLoading = false
      // innerItme.then((res) => {
      //   const data = res.resulter.results
      //   this.innerItemObj = res.resulter
      //   this.inneritemDetailList = JSON.parse(data)
      //   this.hit = res.resulter.hit
      //   this.totalPage = res.resulter.totalPage
      //   this.curPage = res.resulter.curPage
      //   this.pageSize = res.resulter.pageSize
      // })
      const data = innerItme.resulter.results
      this.innerItemObj = innerItme.resulter
      this.inneritemDetailList = JSON.parse(data)
      this.hit = innerItme.resulter.hit
      this.totalPage = innerItme.resulter.totalPage
      this.curPage = innerItme.resulter.curPage
      this.pageSize = innerItme.resulter.pageSize
    },
    // 书内检索页码
    async handleCurrentChangeSub(val) {
      if (await this.$loginAuthentication.intercept(0)) {
        this._initBookInnerSearch(val)
      }
    },
    // showDirectory
    async handleShowDirectory(boolean) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.showDirectory = boolean
        const itemId = this.$route.query.BookID
        const queryInner = this.innerKeyword || this.$route.query.queryInner
        this.$router.push({ path: 'detail', query: { BookID: itemId, queryInner: queryInner, show: boolean } })
      }
    },
    // 书内检索
    handleClickSearch () {
      const itemId = this.$route.query.BookID
      if ((this.innerKeyword).trim() === '') {
        alert('请输入检索词')
        return
      }
      const queryInner = this.innerKeyword || this.$route.query.queryInner
      this.$router.push({path: 'detail', query: {BookID: itemId, queryInner: queryInner, show: 'false'}})
      if (this.$route.query.queryInner) {
        this.showDirectory = false
        this.showBookSearchBtn = true
      }
      this.inneritemDetailList = []
      this.showList = true
      // this.showLoading = true
      this._initBookInnerSearch()
      this.isShowList(this.hit)
    },
    // 志书阅读
    async handleClickRead(id) {
      if (await this.$loginAuthentication.intercept(0)) {
        // 整书2
        this.$store.dispatch('savSourceType', 2)
        if (this.userinfo.users.length) {
          this.$store.dispatch('saveCurrentBookId', 0)
          this.$loginAuthentication.isAppleWechatOrQQ(READ_URL + id + RESOURCE_TYPE_READ);
        } else {
          let counter = 1
          this.$store.dispatch('saveCounter', counter)
          this.$store.dispatch('saveCurrentBookId', id)
          window.location.href = LOGIN_IN_URL + window.encodeURIComponent(window.location.href)
        }
      }
    },
    // 条目阅读
    async handleClickItemRead(id) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.$store.dispatch('savSourceType', 1)
        if (this.userinfo.users.length) {
          this.$store.dispatch('saveCurrentBookId', 0)
          this.$loginAuthentication.isAppleWechatOrQQ(READ_URL + id + RESOURCE_TYPE_ITEM_READ);
        } else {
          let counter = 1
          this.$store.dispatch('saveCounter', counter)
          this.$store.dispatch('saveCurrentBookId', id)
          window.location.href = LOGIN_IN_URL + window.encodeURIComponent(window.location.href)
        }
      }
    },
    // 条目下载
    async handleClickItemDown(id) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.$store.dispatch('savSourceType', 3)
        if (this.userinfo.users.length) {
          this.$store.dispatch('saveCurrentBookId', 0)
          this.$loginAuthentication.isAppleWechatOrQQ(READ_URL + id + RESOURCE_TYPE_ITEM_DOWN);
        } else {
          let counter = 1
          this.$store.dispatch('saveCounter', counter)
          this.$store.dispatch('saveCurrentBookId', id)
          window.location.href = LOGIN_IN_URL + window.encodeURIComponent(window.location.href)
        }
      }
    },
    // ajax 获取数据
    getData (opt) {
      const itemDetail = reqSearch(opt)
      itemDetail.then((res) => {
        const data = res.resulter.results
        const list = JSON.parse(data)
        return list
      })
    },
    // 初始化滚动
    _initScroll () {
      // 列表显示后创建
      this.leftScroll = new BScroll('.stoolbar-dir', {
        probeType: 2,
        click: true,
        mouseWheel: true,
        resizePolling: 60
      })
      this.contentScroll = new BScroll('.content_right', {
        probeType: 2, // 因为惯性滑动不会触发
        click: true,
        mouseWheel: true,
        resizePolling: 60
      })

      // 给右侧列表绑定scroll监听
      this.contentScroll.on('scroll', ({x, y}) => {
        this.scrollY = Math.abs(y)
      })
      // 给右侧列表绑定scroll结束监听
      this.contentScroll.on('scrollEnd', ({x, y}) => {
        this.scrollY = Math.abs(y)
      })
    },
    // 初始化tops
    _initTops () {
      // 1.初始化tops
      const tops = []
      let top = 0
      tops.push(top)
      // 2.收集
      // 找到所有分类li
      const lis = this.$refs.contentUl.children
      // console.dir(this.$refs.contentUl)
      // 伪数组转化真数组
      Array.prototype.slice.call(lis).forEach(li => {
        top += li.clientHeight
        tops.push(top)
      })
      // 3.更新数据
      this.tops = tops
    },
    clickMenuItem (index) {
      // 使用右侧列表滑动到对应的位置
      const scrollY = this.tops[index]
      // 立即更新ScrollY
      this.scrollY = scrollY
      // 平滑互动右侧列表
      this.contentScroll.scrollTo(0, -scrollY, 300)
    },
    // 向上滑动
    handleScrollUp () {
      if (this.clickCurrentIndex) {
        this.clickCurrentIndex = this.clickCurrentIndex - 1
        this.clickMenuItem(this.clickCurrentIndex)
      }
    },
    // 向下滑动
    handleScrollDown () {
      if (this.clickCurrentIndex < this.tops.length - 2) {
        this.clickCurrentIndex = this.clickCurrentIndex + 1
        this.clickMenuItem(this.clickCurrentIndex)
      }
    },
    // 显示隐藏itemList
    isShowItemList (e) {
　    e.target.classList.toggle("open")
      e.target.parentNode.nextElementSibling.classList.toggle("hide")
      this._initTops()
    },
    // showList
    isShowList (val) {
      if (val) {
        this.showList = true
      } else {
        this.showList = false
      }
    },
    async focusHandle() {
      this.readonlyShow = true;
      if (await this.$loginAuthentication.intercept(1)) {
        this.readonlyShow = false;
      } else {
        this.$message.warning('请先登录账号！');
      }
    }
  },
  watch: {
    hit (val) {
      this.isShowList(val)
    },
    $route: {
      handler: function (val) {
        this.$loginAuthentication.intercept(0)
      },
      deep: true,
      immediate:true
    }
  }
}
</script>

<style lang="less" scoped>
.hide {
  display: none
}
.entry-wrapper {
  background: #e9edf0;
  min-height: 800px;
  // padding-bottom: 38px;
  &::after {
    content: "";
    position: absolute;
    background: url("../../assets/imgs/bg-lf.png") no-repeat;
    width: 204px;
    height: 226px;
    top: 680px;
  }
  &::before {
    content: "";
    position: absolute;
    background: url("../../assets/imgs/bg-rt.png") no-repeat;
    width: 204px;
    height: 226px;
    top: 920px;
    right: 0;
  }
  .entry-inner {
    position: relative;
    z-index: 1;
    overflow: hidden;
    background: #fff;
    min-height: 860px;
  }
}
.elipse () {
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.pagination_position {
  position: absolute;
  left: -124px;
  top: 555px;
}
.contain_wrapper {
  box-sizing: border-box;
  margin: 0 auto;
  height: 735px;
  width: 1200px;
  padding: 32px 0 42px 0;
  .left {
    width:240px;
    height:679px;
    background:rgba(244,244,244,1);
    display: inline-block;
    margin-left: 20px;
    .left_content {
      margin: 0 auto;
      width: 220px;
      color: #333333;
      font-size: 14px;
      p {
        margin: 8px 0;
      }
       .content {
        margin: 10px 10px;
        font-size: 14px;
        line-height: 20px;
        width: 196px;
        max-height: 234px;
        color: #666666;
        line-height: 19px;
        white-space: normal;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 11;
        overflow: hidden;
        white-space: pre-wrap;
      }
    }
    .book_img {
      min-height: 320px;
      margin: 0 auto;
      width: 200px;
      border-bottom: 1px dotted #CCCCCC;
      .img-btn {
        margin: 0 auto;
        margin-top: 38px;
        display: block;
        width: 160px;
        height: 222px;
        border: 2px solid #dbcfc8;
      }
      .title {
        color: #333333;
        text-align: center;
        font-size: 18px;
        line-height: 28px;
        margin: 20px 0;
        max-height: 50px;
        width: 200px;
        .elipse();
        white-space: pre-wrap;
      }
      .reading-btn{
        width:76px;
        color: #1743A5;
        height:28px;
        background:rgba(245,248,255,1);
        border:1px solid rgba(105,124,164,1);
        border-radius:14px;
        text-align: center;
        line-height: 28px;
        margin: 0 auto;
        margin-top: 18px;
        font-size: 14px;
        cursor: pointer;
        &:hover {
          background: rgba(105,124,164,1);
          color: #fff;
        }
        .reading-icon {
          margin-right: 6px;
        }
      }
    }
  }
  .secTitle {
    padding-left: 30px;
    .elipse();
  }
  .thirTitle {
     padding-left: 68px;
     .elipse();
  }
  .firtitle {
    padding-left: 6px;
    .elipse();
  }
  .right {
    width: 910px;
    height: 658px;
    border-top: none;
    float: right;
    #list {
      padding-left: 20px;
      padding-right: 20px;
    }
    ul#list {
      //padding-top: 10px;
      //padding-left: 20px;
      font-size: 14px;
      height: 99999px;
      h3 {
        height: 42px;
        border-bottom: 1px dotted #e2d7d1;
        line-height: 42px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        display: block;
        img {
          margin-left:4px;
        }
      }
    }
    i.open {
      background-image: url(./img/icon-tree-opened.png);
    }
    i {
      display: inline-block;
      height: 16px;
      width: 16px;
      background: url(./img/icon-tree-closed.png) no-repeat;
      line-height: 16px;
      cursor: pointer;
      position: relative;
      top: 3px;
    }
    .headTop {
      width: 910px;
      height: 40px;
      background: #fff;
      position: relative;
      div {
        cursor: pointer;
      }
      .on {
        background: #94491f;
        color: #fff;
      }
      .directory{
        width: 144px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 16px;
        border-radius: 3px 3px 0 0;
        float: left;
        background: #BBBBBB;
        color: #FFF;
        &.on {
          background: #4160A5;
          color: #fff;
        }
      }
      .book_search-btn {
        width: 144px;
        height: 40px;
        background: #e5e5e5;
        color: #333333;
        line-height: 40px;
        text-align: center;
        font-size: 16px;
        border-radius: 3px 3px 0 0;
        float: left;
        margin-left: 10px;
        &.on {
          background: #4160A5;
          color: #fff;
        }
      }
      .searchInput {
        float: right;
        margin-right: 23px;
        box-sizing: border-box;
        width:224px;
        height:32px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(65, 96, 165, 1);
        border-radius:4px;
        line-height: 30px;
        padding-left: 10px;
        font-size: 14px;
      }
      .searchIcon {
        position: absolute;
        right: 7px;
        top: 7px;
        color: #1D3A6C;
        margin-right: 23px;
        font-size: 16px;
        cursor: pointer;
      }
    }
    .content_inner {
      height: 750px;
      width: 910px;
      position: relative;
      .content_left {
        width:240px;
        height:748px;
        background:rgba(249,249,249,1);
        border:1px solid rgba(238, 238, 238, 1);
        float: left;
        position: relative;
        // left: 28px;
        // top: 40px;
        .stoolbar-tree {
          border-left: 1px #ddd solid;
          border-right: 1px #ccc solid;
          height: 470px;
          position: absolute;
          left: 28px;
          top: 40px;
          .stoolbar-tree-top {
            background: url(./img/sprite.png) no-repeat 0 0;
            height: 10px;
            overflow: hidden;
            position: absolute;
            width: 10px;
            left: -5px;
            bottom: 0;
          }
          .stoolbar-tree-bottom{
            background: url(./img/sprite.png) no-repeat 0 0;
            height: 10px;
            overflow: hidden;
            position: absolute;
            width: 10px;
            left: -5px;
          }
        }
        .stoolbar-btn {
          position: absolute;
          right: 20px;
          top: 40px;
          z-index: 100;
          .stoolbar-btn-up {
            background: url(./img/sprite.png) no-repeat;
            display: block;
            height: 25px;
            width: 22px;
            background-position: -80px 0;
            &:hover {
              background-position: -50px 0;
            }
          }
          .stoolbar-btn-down {
            background: url(./img/sprite.png) no-repeat;
            display: block;
            height: 25px;
            width: 22px;
            background-position: -80px -25px;
            &:hover {
              background-position: -50px -25px;
            }
          }
        }
        .stoolbar-dir {
          height: 450px;
          overflow: hidden;
          position: relative;
          left: 0;
          top: 8px;
          width: 230px;
          padding-left: 10px;
          margin-top: 42px;
          ul {
            position: absolute;
            left: 28px;
            font-size: 14px;
            li {
              height: 40px;
              width: 200px;
              margin-left: -13px;
              .elipse();
              h3 {
                width: 200px;
                margin-left: 13px;
              }
            }
          }
          .current {
            h3 {
              position: relative;
              .stoolbar-dir-dot {
                background: url(./img/spriteJt.png) no-repeat;
                height: 16px;
                width: 26px;
                position: absolute;
                top: 12px;
                left: -10px;
              }
            }
          }
          .stoolbar-dir-dot {
            height: 40px;
            line-height: 40px;
            position: absolute;
            left: -4px;
            overflow: hidden;
            width: 10px;
            background: url(./img/sprite.png) no-repeat 0 -34px;
          }
          .zs_detail_title {
            height: 40px;
            display: block;
            line-height: 40px;
            margin-left: 20px;
            width: 180px;
            .elipse();
          }
        }
      }
      .content_right {
        width:650px;
        height:748px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(238, 238, 238, 1);
        float: left;
        overflow: hidden;
        padding-top: 1px;
        .iconfont {
          color: #d93838;
          margin: 0 2px;
        }
        a {
          &:hover {
            text-decoration: underline;
            color:rgba(65, 96, 165, 1);
          }
        }
      }
    }
  }
}
.content_search {
  border: 1px solid #EEEEEE;
  height: 700px;
  width: 889px;
  position: relative;
  padding-top: 20px;
  overflow: hidden;
  .loading {
    height: 100%;
  }
  .searchItem {
    margin: 0 auto;
    box-sizing: border-box;
    height: 60px;
    display: inline-block;
    border-bottom: 1px dotted #D1D9E2;
    width: 858px;
    margin-left: 26px;
    position: relative;
    &::after {
      content: '';
      height: 100%;
      display: inline-block;
      vertical-align: middle;
    }
    .title {
      display: inline-block;
      vertical-align: middle;
    }
    .item-title {
      max-width: 600px;
      line-height: 31px;
      display: inline-block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      vertical-align: middle;
      font-size: 14px;
      color: #333333;
      cursor: pointer;
      &.item-num {
        text-align: center;
        width:18px;
        height:18px;
        font-size: 12px;
        line-height: 18px;
        background:rgba(65,96,165,1);
        color: #FFFFFF;
        margin-left: 27px;
        margin-right: 7px;
      }
    }
    div {
      width:76px;
      height:28px;
      background:rgba(245,248,255,1);
      border:1px solid rgba(105,124,164,1);
      border-radius:14px;
      cursor: pointer;
      float: right;
      font-size: 13px;
      line-height: 28px;
      text-align: center;
      color: #1743A5;
      margin-left: 10px;
      margin-top: 15px;
      &:hover {
        background: rgba(105,124,164,1);
        color: #fff;
      }
    }
  }
  .searchWarn {
    font-size: 16px;
    text-align: center;
    line-height: 500px;
    i{
      margin: 0 5px;
      vertical-align: baseline;
    }
    .wf-icon {
      font-family: "wf-icon" !important;
      font-size: 16px;
      font-style: normal;
      -webkit-font-smoothing: antialiased;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Detail/Detail.vue